export const environment = {
    BaseUrl: "https://api.oevent.zimotechnologies.in",
    ChatSocketUrl: "wss:/api.oevent.zimotechnologies.in/chat-ws",
    SocketUrl: "wss:/api.oevent.zimotechnologies.in/notification-ws",
    thawaniPaymentUrl: "https://checkout.thawani.om"
}
export const googleMapsApiKey = "AIzaSyAmpmxk6VmELQyseSzK_OM1aOUkktYobus";
export const thawaniPayment_publishable_key = "mfgP0UorfSxuGGbQJaL43Dfu5Yiba1"
